
// http://121.36.13.81:4067/geoserver/satelliteview/wms?satelliteview:1540952798657-Countries

/* global  Cesium */

function getTMSLayer (layerinfo) {
  let regc = Cesium.Rectangle.MAX_VALUE
  if (layerinfo.extent) {
    const _extent = layerinfo.extent
    regc = new Cesium.Rectangle(
      Cesium.Math.toRadians(_extent[0]),
      Cesium.Math.toRadians(_extent[1]),
      Cesium.Math.toRadians(_extent[2]),
      Cesium.Math.toRadians(_extent[3]))
  }

  const oURL = layerinfo.url
  const tileSize = layerinfo.tileSize ? layerinfo.tileSize[0] : 512
  const tileType = layerinfo.tileType ? layerinfo.tileType : 'jpg'

  const TMSprovider = new Cesium.TileMapServiceImageryProvider({
    url: oURL,
    fileExtension: tileType,
    maximumLevel: 8,
    tileMatrixSetID: 'EPSG:4326',
    tilingScheme: new Cesium.GeographicTilingScheme({
      numberOfLevelZeroTilesX: 2,
      // optional The number of tiles in the X direction at level zero of the tile tree.
      numberOfLevelZeroTilesY: 1
    }),
    rectangle: regc,
    tileWidth: tileSize,
    tileHeight: tileSize
    // 经纬度范围 此处可以有效减少无效url 申请
    // rectangle: new Cesium.Rectangle(
    //   Cesium.Math.toRadians(70.0),
    //   Cesium.Math.toRadians(0.0),
    //   Cesium.Math.toRadians(140.0),
    //   Cesium.Math.toRadians(60.0))
  })
  return TMSprovider
}

export { getTMSLayer }
